<template>
  <div>
    

    <b-alert variant="danger" :show="progressData === undefined">
      <h4 class="alert-heading">Error fetching progress data</h4>
      <div class="alert-body">
        No Progress found with this progress id. Check
        <b-link class="alert-link" :to="{ name: 'progress-list' }">
          Progress List
        </b-link>
        for other progress.
      </div>
    </b-alert>
    <div v-if="progressData && Object.keys(progressData).length > 0">

    <modal-upload-document
      :project_progress_id="project_progress_id"
      :document-data="documentData"
      @refetch-data="refetchData"
    />

    <Modal-Pdf :title="title" :pdf-url="pdfUrl" />

    <modal-image-viewer-single :image-path="previewImage"></modal-image-viewer-single>

    <modal-approval
      :approve-data="approveData"
      :project_progress_number="progressData.project_progress_number"
      :approvalStatusOptions="approvalStatusOptions"
      @refetch-data="refetchData"
    />
      <b-card no-body class="p-1 px-2">
        <!-- project progress Info: Top col -->
        <div
          class="d-flex flex-wrap align-items-center justify-content-between"
        >
          <h4 class="mb-0 ml-0 mb-1 mb-sm-0 font-weight-bolder text-nowrap">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-chart-simple" />
            進度資料
          </h4>
          <div class="d-flex flex-wrap justify-content-end">
            <b-button
              v-if="ability.can('update', 'progresses')"
              class="px-3 mx-1 mobile-w100 mb-1 mb-sm-0 backgroundColor1 no-border"
              :to="{
                name: 'progress-edit',
                params: { id: progressData.id },
              }"
              ><feather-icon
                class="mr-50"
                size="14"
                icon="Edit2Icon"
              />修改</b-button
            >
            <b-button
              class="px-3 mx-1 mobile-w100 mb-1 mb-sm-0"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              返回
            </b-button>
            <b-button
              class="px-3 mx-1 mobile-w100 mb-1 mb-sm-0 no-border backgroundColor3 colorBlack"
              variant="outline-danger"
              v-if="ability.can('delete', 'progresses')"
              @click="deleteProgress(progressData.id)"
              ><feather-icon
                class="mr-50"
                size="14"
                icon="Trash2Icon"
              />刪除</b-button
            >
          </div>
        </div>
        <hr />
        <b-row class="info-wrap px-1">
          <b-col cols="12" sm="12" md="4">
            <div class="mb-25">
              <label class="mr-50">編號：</label
              >{{ progressData.project_progress_number }}
            </div>
            <div class="mb-1">
              <!-- <label class="info-label">項目編號：</label> -->
              <label class="mr-50">項目名稱：</label
              <span class="">{{ progressData.project_name }}</span>
            </div>
            <h4 class="mb-2 font-weight-bolder">
              {{ progressData.project_address }}
            </h4>
            <!-- <div class="">
              {{ progressData. }}
            </div> -->
          </b-col>

          <b-col cols="12" sm="6" md="4">
            <div class="info-item">
              <b class="info-item-label">施工單號：</b>
              <span>{{ progressData.order_number }}</span>
            </div>
            <div class="info-item">
              <b class="info-item-label">支付日期：</b>
              <span>{{ progressData.pay_date }}</span>
            </div>
            <div class="info-item">
              <b class="info-item-label">薪金支出：</b>
              <span>{{ formatCurrency(progressData.total_amount) }}</span>
            </div>
          </b-col>

          <b-col cols="12" sm="6" md="4">
            <div class="info-item d-flex">
              <b class="info-item-label">狀態：</b>
              <!-- <span>{{ progressData.approval_status.name }}</span> -->
              <a
                href="javascript:void(0)"
                @click="handleApproval(progressData)"
                class="d-flex align-items-center"
                :style="{
                  color: getApprove(progressData.approve_status_id).color,
                }"
              >
                <feather-icon class="mr-25" icon="EditIcon" />{{
                  getApprove(progressData.approve_status_id).name
                }}</a
              >
            </div>
            <div class="info-item">
              <b class="info-item-label">更新者：</b>
              <span>{{
                progressData.modifier && progressData.modifier.name
              }}</span>
            </div>
            <div class="info-item">
              <b class="info-item-label">創建日期：</b>
              <span>{{ getDateTime(progressData.created_at) }}</span>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-row class="align-items-stretch">
        <b-col md="6">
          <b-card
            v-if="
              progressData.salary_items && progressData.salary_items.length > 0
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <h4
                class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-1 font-weight-bolder"
              >
                工資
              </h4>
            </div>
            <div class="mt-2 info-container">
              <b-row
                class="p-2 m-0 radius-round backgroundColor5 mb-1"
                v-for="(worker, index) in progressData.salary_items"
                :key="`worker${index}`"
              >
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <b class="label">師傅:</b>
                    <span>{{ getWorker(worker.worker_id) && getWorker(worker.worker_id).name_cn }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">職位：</b>
                    <span>{{ worker.position }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">工資：</b>
                    <span
                      >{{ worker.working_days }} X ${{ worker.day_salary }}日 =
                      ${{ worker.total_salary }}
                    </span>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <b class="label">開工日期</b>
                    <span>{{ worker.working_date }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <b-card
            v-if="progressData.cost_items && progressData.cost_items.length > 0"
          >
            <div class="d-flex align-items-center justify-content-between">
              <h4
                class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-2 font-weight-bolder"
              >
                其他成本
              </h4>
            </div>
            <div class="mt-2 info-container">
              <b-row
                class="p-2 m-0 radius-round backgroundColor3 mb-1"
                v-for="(cost, index) in progressData.cost_items"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <b class="label">商品：</b>
                    <span>{{ getProduct(cost.product_id).product_name }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">總金額：</b>
                    <span
                      >{{ parseFloat(Number(cost.quantity).toString()) }} X ${{ cost.unit_price }} = ${{
                        cost.amount
                      }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <span class="label">備註：</span>
                    <span>{{ cost.item_description }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card id="downloadWrapper" style="height: calc(100% - 2rem);">
            <div class="d-flex align-items-center justify-content-between">
              <h4
                class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-2 font-weight-bolder"
              >
                文件
              </h4>
              <b-button
                variant="primary"
                class="d-flex py-50 px-3 align-items-center"
                @click="handleModelDocument(false)"
                v-if="ability.can('update', 'progresses')"
              >
                <feather-icon icon="PlusIcon" size="20" />
                上傳</b-button
              >
            </div>
            <div class="mt-2">
              <b-table
                ref="refProgressDocumentsTable"
                class="position-relative"
                :items="documents"
                responsive
                :fields="documentTableColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <!-- Column: file_url -->
                <template #cell(file_url)="data">
                  <!-- <a target="_blank" :href="data.item.file_url">下載</a> -->
                  <a class="color1" @click="previewImageSet(data.item)">預覽</a>
                </template>

                <template #cell(created_at)="data">
                  {{ getDateTime(data.item.created_at) }}
                </template>

                <template #cell(actions)="data">
                  <b-dropdown
                    class="action-trigger-btn"
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content class="">
                      <feather-icon
                        icon="EyeIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-item
                      v-if="ability.can('update', 'project-progress') || false"
                      @click="handleModelDocument(data.item)"
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">修改文件</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="ability.can('delete', 'project-progress') || true"
                      @click="removeDocument(data.item.id)"
                    >
                      <feather-icon icon="Trash2Icon" />
                      <span class="align-middle ml-50">刪除文件</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BTable,
  BRow,
  BCol,
  BAlert,
  BLink,
  BButton,
  BDropdown,
  BDropdownItem,
  BCollapse,
  VBToggle,
} from "bootstrap-vue";
import { ref, watch, onUnmounted, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import router from "@/router";
import progressStoreModule from "../progressStoreModule";
import ability from "@/libs/acl/ability";
import ModalUploadDocument from "../modal/ModalUploadDocument";
import ModalPdf from "@/layouts/components/file/ModalPdf.vue";
import ModalImageViewerSingle from "@/layouts/components/file/ModalImageViewerSingle.vue";
import ModalApproval from "../modal/ModalApproval.vue";
export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BAlert,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BCollapse,
    vSelect,
    ModalUploadDocument,
    ModalApproval,
    ModalPdf,
    ModalImageViewerSingle,
  },
  data() {
    return {
      ability,
      documentData: {},
      pdfUrl: null,
      loadingPDF: false,
      title: null,
      previewImage: null,
      id: null,
      approveData:null,
    };
  },
  directives: {
    "b-toggle": VBToggle,
  },
  methods: {
    formatCurrency,
    hide() {
      this.$router.replace("/progress/list");
    },
    handleApproval(item) {
      this.approveData = {
        id: item.id,
        approve_status_id: item.approve_status_id,
      };
      this.$bvModal.show("modal-approval");
    },
    handleModelDocument(item) {
      if (item) {
        this.documentData = item;
      } else {
        this.documentData = { id: 0};
      }
      this.$bvModal.show("modal-upload-document");
    },
    previewImageSet(item) {
      if (item.type === "application/pdf") {
        this.loadingPDF = true;
      
            const filepdf = new Blob([item.file_url], {
              type: "application/pdf",
            });
            const fileURL = URL.createObjectURL(filepdf);
            this.pdfUrl = fileURL;
            this.loadingPDF = false;
            this.$bvModal.show("modal-pdf");
      } else if (
        item.type == "image/jpeg" ||
        item.type == "image/jpg" ||
        item.type == "image/png" ||
        item.type == "image/gif" ||
        item.type == "image/webp" ||
        item.type == "image/svg" ||
        item.file_url
      ) {
        this.previewImage = item.file_url;
        this.$bvModal.show("modal-image-viewer-single");
      }
    },
    deleteProgress(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("progress/deleteProgress", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    removeDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("progress/deleteProgressDocument", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  setup() {
    const progressData = ref(null);
    const progress_APP_STORE_MODULE_NAME = "progress";

    if (!store.hasModule(progress_APP_STORE_MODULE_NAME))
      store.registerModule(progress_APP_STORE_MODULE_NAME, progressStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(progress_APP_STORE_MODULE_NAME))
        store.unregisterModule(progress_APP_STORE_MODULE_NAME);
    });

    const documentTableColumns = ref([
      {
        key: "file_name",
        stickyColumn: true,
        label: "檔案名稱",
        sortable: true,
      },
      { key: "file_url", label: "預覽", sortable: true },
      { key: "created_at", label: "上傳日期", sortable: true },
      { key: "actions", label: "操作" },
    ]);

    const project_progress_id = ref(null);
    const documents = ref([]);

    const refetchData = () => {
      store
        .dispatch("progress/fetchProgress", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          progressData.value = response.data.progress;
          progressData.value.approve_status_id = progressData.value
            .approve_status_id
            ? progressData.value.approve_status_id
            : 1;

          documents.value = response.data.progress.documents;
          project_progress_id.value = progressData.value.id
        })
        .catch((error) => {
          console.log("error when fetching worker", error);
          if (error.response.status === 404) {
            progressData.value = undefined;
          }
        });
    };

    const projectOptions = ref([]);
    const productOptions = ref([]);
    const workerOptions = ref([]);
    const approvalStatusOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          projects: true,
          products: true,
          workers: true,
          approve_status: true,
        })
        .then((response) => {
          projectOptions.value = response.data.projects;
          productOptions.value = response.data.products;
          workerOptions.value = response.data.workers;
          approvalStatusOptions.value = response.data.approve_statuses;
        });
    };

    const project_address = ref("");

    // watch(
    //   () => progressData.value.product_id,
    //   (newVal) => {
    //       console.log('newVal',newVal)
    //     if (projectOptions.value && projectOptions.value.length > 0) {
    //       var target = projectOptions.value.filter(
    //         (ele) => ele.id == newVal
    //       )[0];
    //       project_address.value = target.address;
    //     }
    //   }
    // );

    const getProject = (id) => {
      return (
        projectOptions.value &&
        projectOptions.value.length > 0 &&
        projectOptions.value.filter((ele) => ele.id == id)[0]
      );
    };

    const getWorker = (id) => {
      return (
        workerOptions.value &&
        workerOptions.value.length > 0 &&
        workerOptions.value.filter((ele) => ele.id == id)[0]
      );
    };

    const getProduct = (id) => {
      return (
        productOptions.value &&
        productOptions.value.length > 0 &&
        productOptions.value.filter((ele) => ele.id == id)[0]
      );
    };

    const getApprove = (id) => {
      if (id) {
        const obj =
          approvalStatusOptions.value &&
          approvalStatusOptions.value.length > 0 &&
          approvalStatusOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return "- -";
      }
    };

    onMounted(() => {
      refetchData();
      refetchOption();
    });

    return {
      progressData,
      projectOptions,
      productOptions,
      workerOptions,
      approvalStatusOptions,
      documents,
      documentTableColumns,
      refetchData,
      project_address,
      getProject,
      getWorker,
      getProduct,
      getApprove,
      project_progress_id
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
<style lang="scss" scoped>
.info-wrap {
  .info-label {
    display: inline-block;
    width: 100px;
  }
  .info-item {
    margin-bottom: 1rem;
    .icon {
      display: inline-block;
      margin-right: 1rem;
      width: 15px;
      svg {
        margin: auto;
        display: block;
      }
    }
  }
}
</style>
